import type { Column } from '@tanstack/react-table';
import { DatePicker } from '@ksyos/design-system';

type ColumnDateAfterFilterProps<T> = {
    column: Column<T, unknown>;
};

export function ColumnDateAfterFilter<T>({ column }: Readonly<ColumnDateAfterFilterProps<T>>) {
    const columnFilterValue = column.getFilterValue();

    return (
        <DatePicker
            onChange={column.setFilterValue}
            value={(columnFilterValue as Date) ?? null}
        />
    );
}
